<template>
  <div class="news-section">
    <!-- Custom Tabs -->
    <div class="news-tabs">
      <div v-for="tab in tabs" :key="tab.name" :class="['news-tab', { 'active-tab': selectedTab === tab.name }]" @click="changeTab(tab.name)">
        <span v-if="selectedTab === tab.name" class="red-dot">●</span>
        {{ tab.label }}
      </div>
    </div>

    <!-- News List -->
    <div v-if="newsList.length || loading">
      <el-row v-loading="loading" class="news-container">
        <el-col v-for="news in newsList" :key="news.url" :span="24" class="news-item">
          <el-row align="middle">
            <el-col :span="2">
              <el-image :src="news.image_url" fit="cover" class="news-image" />
            </el-col>
            <el-col :span="22">
              <div class="news-content" @click="openNewsPopup(news)">
                <div class="news-title">{{ news.title }}</div>
                <div class="news-meta">
                  <span class="news-source">{{ news.source }}</span>
                  <span class="news-date">{{ formatDate(news.pub_date) }}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <!-- Pagination -->
      </el-row>
      <div v-if="pagination.total_entries > pagePerEntries" class="pagination-container">
        <el-pagination layout="prev, pager, next" :current-page="pagination.current_page" :page-size="pagePerEntries" :total="pagination.total_entries" @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <div v-else>
      <NoDataFound style="padding: 40px 0;"></NoDataFound>
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import moment from 'moment';
import NoDataFound from '@/components/NoDataFound.vue';

export default {
  name: 'NewsSectionComponent',
  components: { NoDataFound },
  props: ['newsData'],
  data() {
    return {
      tabs: [
        { name: 'All News', label: 'Live News' },
        { name: 'New Offerings', label: 'New Offerings' },
        { name: 'Financial Results', label: 'Financial Results' },
      ],
      selectedTab: 'All News',
      newsList: [],
      loading: false,
      pageNumber: 1,
      pagePerEntries: 5,
      pagination: {
        total_entries: 0,
        current_page: 1,
      },
    };
  },
  methods: {
    changeTab(tabName) {
      this.selectedTab = tabName;
      this.pageNumber = 1;
      this.getNewsData();
    },
    getNewsData() {
      this.loading = true;
      serverAddr
        .get('/stockants/get_stored_news_data', {
          params: {
            page_number: this.pageNumber,
            page_per_entries: this.pagePerEntries,
            category: this.selectedTab,
          },
        })
        .then((response) => {
          if (response.data.status === 'success') {
            this.newsList = response.data.data;
            this.pagination = response.data.pagination;
          } else {
            console.error('Failed to fetch news data');
            this.newsList = [];
          }
        })
        .catch((error) => {
          console.error('Error fetching news:', error);
          this.newsList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handlePageChange(newPage) {
      this.pageNumber = newPage;
      this.getNewsData();
    },
    formatDate(date) {
      return moment(date).format('MMM DD, YYYY hh:mm A');
    },
    openNewsPopup(news) {
      // console.log("News Clicked:", news);
      this.$emit('open-news-popup', news); // Emit event to parent with news data
    },
  },
  mounted() {
    this.getNewsData();
  },
};
</script>

<style lang="scss" scoped>
.news-section {
  width: 100%;
  max-width: 900px;
  margin: 0 auto 15px;
  background: white;
  border-radius: 5px;

  .news-tabs {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #dcdcdc;
  }

  .news-tab {
    flex: 1;
    text-align: center;
    padding: 10px 2px;
    cursor: pointer;
    font-size: 11px;
    font-weight: 500;
    transition: all 0.3s ease;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  .active-tab {
    background: linear-gradient(180deg, #2d2e8d 0%, #0c0d27 100%);
    color: white;
  }

  .red-dot {
    color: red;
    font-size: 12px;
  }

  .news-container {
    padding: 10px 0;
  }

  .news-item {
    padding: 10px 15px;
    display: flex;
    align-items: center;

    .news-image {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
    }

    .news-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 15px;
      cursor: pointer;

      .news-title {
        font-size: 12px;
        font-weight: 600;
        color: #000;
        text-decoration: none;
        padding-left: 20px;

        &:hover {
          text-decoration: underline;
        }
      }

      .news-meta {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 10px;
        font-weight: 500;
        color: #818181;
        margin-top: 10px;
        padding-left: 20px;
      }

      .news-source {
        flex: 1;
        text-align: left;
      }

      .news-date {
        text-align: right;
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: center;
  }
}
</style>
